var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTeleGeofenceUnavailableContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_tele_geofence_unavailable",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_476",
    x: 3.473,
    y: 0.908,
    width: 29.059,
    height: 34.186,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 36,
    height: 36,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-511.488 -856)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 511.49, 856)",
    filter: "url(#Path_476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_476-2",
    "data-name": "Path 476",
    d: "M22577.49,24367.467a11.529,11.529,0,0,1,23.059,0c0,8.979-9.369,16.719-11.529,16.719S22577.49,24376.445,22577.49,24367.467Z",
    transform: "translate(-22571.02 -24352.09)",
    fill: "#ff0700"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon-2",
    "data-name": "Icon",
    d: "M3.881,3.058v-.21A8.2,8.2,0,0,1,4.159.522,3.52,3.52,0,0,1,4.931-.871a6.034,6.034,0,0,1,1.22-.973,5.666,5.666,0,0,0,.884-.674,2.877,2.877,0,0,0,.618-.824,2.269,2.269,0,0,0,.226-1.022,2.013,2.013,0,0,0-.3-1.106,2.034,2.034,0,0,0-.8-.727A2.436,2.436,0,0,0,5.65-6.456a2.478,2.478,0,0,0-1.086.246,2.119,2.119,0,0,0-.848.743A2.438,2.438,0,0,0,3.34-4.211H.464a4.672,4.672,0,0,1,.747-2.568A4.362,4.362,0,0,1,3.085-8.33a6.3,6.3,0,0,1,2.58-.517,6.435,6.435,0,0,1,2.718.541,4.284,4.284,0,0,1,1.833,1.539A4.19,4.19,0,0,1,10.875-4.4a4.352,4.352,0,0,1-.295,1.648,4.057,4.057,0,0,1-.836,1.292A6.087,6.087,0,0,1,8.46-.455a5.365,5.365,0,0,0-1.07.84,2.725,2.725,0,0,0-.614,1.022A4.685,4.685,0,0,0,6.57,2.848v.21ZM5.286,8.1a1.722,1.722,0,0,1-1.252-.517,1.7,1.7,0,0,1-.525-1.26,1.683,1.683,0,0,1,.525-1.244,1.769,1.769,0,0,1,2.5,0,1.738,1.738,0,0,1,.283,2.14,1.867,1.867,0,0,1-.646.642A1.7,1.7,0,0,1,5.286,8.1Z",
    transform: "translate(523.822 874.198)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTeleGeofenceUnavailableContent);
export default __webpack_public_path__ + "static/media/ic_tele_geofence_unavailable_content.3679b91f8bbb1a465e2de130f1b27eb6.svg";
export { ForwardRef as ReactComponent };